var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExternal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 80,
    viewBox: "0 0 81 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.5831 47.0948L71.7338 28.9395C74.4785 26.1949 75.9911 22.5318 75.9911 18.6161C75.9911 14.7003 74.4785 11.0358 71.7339 8.29116C68.9893 5.54656 65.3262 4.03394 61.409 4.03394C57.4946 4.03394 53.8301 5.54514 51.0856 8.28965L37.2041 22.1712C36.4183 22.9569 35.1473 22.9569 34.3616 22.1712C33.5759 21.3854 33.5759 20.1144 34.3616 19.3287L48.243 5.44724C55.5045 -1.81731 67.3197 -1.81418 74.578 5.44724C78.0823 8.9516 80.013 13.6292 80.013 18.6145C80.013 23.6 78.0823 28.2776 74.5779 31.7819L56.4241 49.9372C52.794 53.5674 48.0242 55.3829 43.2567 55.3829C38.4891 55.3829 33.7209 53.5673 30.0894 49.9373C29.3036 49.1516 29.3036 47.8805 30.0893 47.0948C30.875 46.309 32.146 46.309 32.9318 47.0947C38.6247 52.7862 47.8917 52.7861 53.5831 47.0948Z",
    fill: "white",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.4169 32.9052L9.26616 51.0605C6.52153 53.8051 5.00889 57.4682 5.00889 61.3839C5.00889 65.2997 6.52152 68.9642 9.26611 71.7088C12.0107 74.4534 15.6738 75.9661 19.591 75.9661C23.5054 75.9661 27.1699 74.4549 29.9144 71.7103L43.7959 57.8288C44.5817 57.0431 45.8527 57.0431 46.6384 57.8288C47.4242 58.6146 47.4242 59.8856 46.6384 60.6713L32.757 74.5528C25.4955 81.8173 13.6803 81.8142 6.42203 74.5528C2.91771 71.0484 0.987024 66.3708 0.987024 61.3854C0.987024 56.4 2.91774 51.7224 6.4221 48.2181L24.5759 30.0628C28.206 26.4326 32.9758 24.6171 37.7433 24.6171C42.5109 24.6171 47.2791 26.4327 50.9106 30.0627C51.6964 30.8484 51.6964 32.1195 50.9107 32.9052C50.125 33.691 48.854 33.691 48.0683 32.9053C42.3753 27.2138 33.1083 27.2139 27.4169 32.9052Z",
    fill: "white",
    fillOpacity: 0.6
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExternal);
export default __webpack_public_path__ + "static/media/external.60550461.svg";
export { ForwardRef as ReactComponent };